import  * as df from "./dafault";
import { arrayUnique } from './helper';
import Vue from 'vue';
import AppEditor from '~/components/AppEditor';

export default (editor, opts = {}) => {
    const commands = editor.Commands;
    const pns = editor.Panels;
    const sm = editor.StorageManager;
    const md = editor.Modal;

    commands.add('filter-resources-duplicated',{
        run: function(editor,sender,params){

            const default_resources = df.DEFAULT_RESOURCES.map((item)=>{ return{...item,default:true}});
            const opts_resources = opts.resources.map((item)=>{ return{...item,default:true}});
            const local_storage_resources = localStorage.getItem('template_resources');
            const template_resources = (local_storage_resources)? JSON.parse(local_storage_resources) : []
            const resources = arrayUnique(default_resources.concat(opts_resources,template_resources));


            /* const names = resources.map(rsc => rsc.name);
            const resources_filtered = resources.filter(({name}, index) => !names.includes(name, index+1)); */

            return resources;
        }

    });

    commands.add('save-template-resources',{
        run: function(editor,sender,params){
            const template_resources = (params.template_resources) ? params.template_resources : [];
            try {
                localStorage.setItem('template_resources', JSON.stringify(template_resources));
                return true;
            } catch (error) {
                console.log(error);
                return false;
            }
        }

    });

     /* Load the list typography */
     commands.add('load-list-typography', {
        run: function (editor, sender, params) {

            
            let styleManager = editor.StyleManager;
            const resources = editor.runCommand('filter-resources-duplicated');
            let fontProperty = styleManager.getProperty('typography', 'font-family');
            let list = fontProperty.get('list');
    
            const fonts_resources = resources.filter((item)=>{
                return item.type.toLowerCase() == 'font';
            });
            
            for (let i = 0; i < fonts_resources.length; i++) {
                const font = fonts_resources[i];
                list = list.filter((item)=>{
                    return item.name != font.name;
                });
                if(font.active)
                    list.push({ value: font.value , name: font.name });
                    
            }
            fontProperty.set('list', list);
            styleManager.render();

        }
    });

    /* Created the resource in head and footer */
    commands.add('load-resources', {
        run: function (editor, sender, params) {
            /* Add resource header */
            
            let canvas_document = editor.Canvas.getDocument();
            let canvas_html = canvas_document.querySelector('html');
            let canvas_head = canvas_document.querySelector('head');
            let canvas_footer =(canvas_document.querySelector('footer')) ? canvas_document.querySelector('footer'):document.createElement('footer');
            canvas_html.appendChild(canvas_footer);
            const resources_filtered = editor.runCommand('filter-resources-duplicated');
            const external_resources = resources_filtered.filter((item)=>{
                return item.external_resource == true;
            });
            
            for (let i = 0; i < external_resources.length; i++) {
                const resource = external_resources[i];
                let dom_resource = canvas_document.querySelector(`[data-resource="${resource.name}"]`);
                if(resource.active){
                    switch (resource.type.toLowerCase()) {
                        case 'font' || 'style':
                            if(!dom_resource){
                                dom_resource = document.createElement("link");
                                dom_resource.setAttribute("data-resource",resource.name);
                                dom_resource.setAttribute("rel",'stylesheet');
                            }
                            dom_resource.href = resource.url;
                            break;
                        case 'script':
                            if(!dom_resource){
                                dom_resource = document.createElement("script");
                                dom_resource.setAttribute("data-resource",resource.name);
                            }
                            
                            dom_resource.src = resource.url;
                            break;
                        default:
                            break;
                    }

                    if(dom_resource){
                        if(resource.position == 'footer')
                            canvas_footer.appendChild(dom_resource);
                        else
                            canvas_head.appendChild(dom_resource);
                    }
                }else if(!resource.active && dom_resource ){
                    console.log("Remove resource");
                    dom_resource.remove();
                }
                
                    
            }
                
        
        }
    });

    commands.add('open-resources-modal', {
        run: function (editor, sender, params) {
            
            sender && sender.set('active', 0);

            let container = document.createElement('div');
            container.setAttribute('id','vue-app');

            md.setTitle(opts.modal_title)
                .setContent(container)
                    .open();

            new Vue({
                ...AppEditor,
                element:"ModalResources",
                editor:editor,
            }).$mount('#vue-app');
        }
            
    });
    
}